import type { ReactElement } from 'react'
import { useState } from 'react'

import Lightbox from './Lightbox'
import Portal from './Portal'

type Props = Readonly<{
  garanLabel: Core.ProductAttachment
}>

export default function GaranLabel({ garanLabel }: Props): ReactElement {
  const [isOpen, setIsOpen] = useState(false)
  const isPdf = garanLabel.dataUri.toLowerCase().endsWith('.pdf')

  return (
    <>
      <a
        href={garanLabel.dataUri}
        target="_blank"
        rel="noreferrer"
        className="garan-label-link"
        onClick={(event) => {
          if (isPdf) return
          event.preventDefault()
          setIsOpen(true)
        }}
      >
        {garanLabel.label}
      </a>
      {!isPdf && (
        <Portal>
          <Lightbox show={isOpen} closeOnBackdropClick onClose={() => setIsOpen(false)}>
            <img className="garan-label-image" src={garanLabel.dataUri} alt={garanLabel.label} />
          </Lightbox>
        </Portal>
      )}
    </>
  )
}
